<app-block-ui [loading]="loading">
  <ng-container *ngIf="blockUiText; else elseTemplate">
    {{ blockUiText }}
  </ng-container>
  <ng-template #elseTemplate>
    <div [innerHTML]="'TOAST.Action in progress' | translate"></div>
  </ng-template>
</app-block-ui>

<!-- <ng-container *ngIf="formGroup; else elseTemplate"> -->
<div [attr.formGroup]="formGroup ? formGroup : null">
  <div class="main-card">
    <div class="card-header" *ngIf="headerType !== 'none'">
      <div class="flex align-items-center">
        <a
          *ngIf="headerType === 'inner' && backPath"
          class="second-btn back-btn mr-2"
          [routerLink]="backPath"
          ><i class="pi pi-angle-left m-0"></i
        ></a>

        <h1 *ngIf="headerTitle" class="card-title">
          {{ headerTitle }}
        </h1>
      </div>

      <section class="flex align-items-center flex-wrap">
        <ng-content select="[buttons]"></ng-content>
        <a
          *ngIf="dataForPage && showPreviewButton"
          [href]="websiteUrl"
          target="_blank"
          class="main-btn main-btn-outlined mr-2"
        >
          {{ 'BUTTONS.preview' | translate }}
          <i class="pi pi-reply"></i>
        </a>
        <app-button
          *ngIf="showAddButton"
          type="button"
          btnStyle="main"
          styleClass="main-btn"
          [routerLink]="['./add']"
          icon="plus"
          >Create</app-button
        >
        <app-button
          *ngIf="formGroup"
          [disabled]="!formGroup.valid"
          type="button"
          btnStyle="main"
          icon="save"
          (click)="onSubmitForm()"
          >{{ saveBtnText }}
        </app-button>
      </section>
    </div>
    <div class="card-body p-4" [hidden]="!skeletonLoad">
      <app-skeleton></app-skeleton>
    </div>
    <div class="card-body" [hidden]="skeletonLoad">
      <ng-container *ngIf="showSidebar; else withoutSidebarTemplate">
        <div class="grid">
          <div class="col-12 sm:col-8 pr-0 pt-0 pb-0">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </div>
          <div
            class="col-12 sm:col-4 pl-4 border-left-1 mt-2 pt-0 pb-0 border-gray-200 bg-white"
          >
            <section class="m-4 ml-0">
              <ng-content select="[sidebar]"></ng-content>
              <ng-content select="[footerSidebar]"></ng-content>
            </section>
          </div>
        </div>
      </ng-container>
      <ng-template #withoutSidebarTemplate>
        <!-- <div class="p-3"> -->
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <!-- </div> -->
      </ng-template>

      <!-- Wrap content in template -->
      <ng-template #content>
        <div class="p-4">
          <ng-content></ng-content>
        </div>
      </ng-template>
    </div>
  </div>
</div>
